import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { categoryMeta, type VideoType } from "@/mocks/videos";

const SERVICES = [
  { icon: "ri-movie-2-line", title: "多类型内容聚合", desc: "汇集电影、电视剧与短视频，覆盖多种题材与地区。" },
  { icon: "ri-filter-3-line", title: "多维筛选", desc: "按地区、年份、题材、标签组合筛选，快速缩小范围。" },
  { icon: "ri-search-eye-line", title: "关键词搜索", desc: "支持按名称、标签模糊匹配，直达想看的内容。" },
  { icon: "ri-sparkling-line", title: "相关推荐", desc: "基于类型与标签的相似度推荐，发现更多好内容。" },
];

export default function About() {
  useDocumentMeta({
    title: "关于我们-69视频-丰富的视频资源平台",
    description: "了解69视频的定位、服务内容、联系方式与版权说明。69视频为用户提供丰富多样的视频资源浏览与探索体验。",
    keywords: "关于69视频,69视频介绍,视频平台,版权声明,联系方式",
    canonicalPath: "/about",
  });

  return (
    <div className="w-full">
      <section className="w-full px-4 md:px-8 pt-10 pb-12 bg-primary-950">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-primary-950 text-xs font-bold mb-5">
            <i className="ri-video-line" aria-hidden="true"></i>
            关于我们
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-background-50 leading-tight mb-5">
            用更简单的方式，找到你想看的内容
          </h1>
          <p className="text-sm md:text-base text-background-100/85 leading-relaxed">
            69视频是一家集电影、电视剧、短视频等多类型高清视频资源于一体的在线视频平台。
            我们面向广大影视爱好者与短视频观众，通过丰富的分类、多维筛选、关键词搜索与相关推荐，
            帮助用户在观看前快速了解内容信息，提升观影决策效率与探索乐趣。
          </p>
        </div>
      </section>

      <div className="w-full px-4 md:px-8 py-12">
        <section className="mb-14">
          <h2 className="font-heading font-bold text-2xl text-foreground-950 mb-6 flex items-center gap-2">
            <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
            我们提供什么
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {SERVICES.map((s) => (
              <div key={s.title} className="rounded-lg bg-background-100 border border-background-200/70 p-6">
                <span className="w-12 h-12 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center mb-4">
                  <i className={`${s.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <h3 className="font-semibold text-foreground-950 mb-2">{s.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-14">
          <div>
            <h2 className="font-heading font-bold text-2xl text-foreground-950 mb-6 flex items-center gap-2">
              <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
              联系方式
            </h2>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-sm text-foreground-800">
                <span className="w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center text-primary-600">
                  <i className="ri-mail-line text-xl" aria-hidden="true"></i>
                </span>
                商务合作 / 内容反馈：contact@69video.com
              </li>
              <li className="flex items-center gap-3 text-sm text-foreground-800">
                <span className="w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center text-primary-600">
                  <i className="ri-weibo-line text-xl" aria-hidden="true"></i>
                </span>
                官方微博：@69视频官方
              </li>
              <li className="flex items-center gap-3 text-sm text-foreground-800">
                <span className="w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center text-primary-600">
                  <i className="ri-wechat-line text-xl" aria-hidden="true"></i>
                </span>
                微信公众号：69video-official
              </li>
              <li className="flex items-center gap-3 text-sm text-foreground-800">
                <span className="w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center text-primary-600">
                  <i className="ri-time-line text-xl" aria-hidden="true"></i>
                </span>
                服务时间：周一至周五 09:00 - 18:00
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading font-bold text-2xl text-foreground-950 mb-6 flex items-center gap-2">
              <span className="w-1.5 h-6 rounded-full bg-secondary-500"></span>
              平台服务与版权声明
            </h2>
            <div className="rounded-lg bg-background-100 border border-background-200/70 p-6 space-y-4 text-sm text-foreground-700 leading-relaxed">
              <p>
                本站所有内容均为演示示例，仅用于展示信息浏览、分类筛选、搜索与推荐等交互效果，
                <strong>不提供任何真实视频播放或下载功能</strong>。
              </p>
              <p>
                站内出现的视频名称、简介、封面及人物信息均为虚构，如与真实作品存在相似之处纯属巧合。
                正式使用前请替换为已获得合法授权的内容。
              </p>
              <p>
                未经书面许可，任何单位或个人不得以任何形式复制、转载或用于商业用途。
              </p>
            </div>
          </div>
        </section>

        <section className="rounded-lg bg-primary-950 px-6 md:px-12 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-background-50 mb-2">准备好开始探索了吗？</h2>
            <p className="text-sm text-background-100/80">从三大频道中挑选你喜欢的内容，发现下一部心头好。</p>
          </div>
          <div className="flex items-center gap-3 flex-wrap">
            {(["movie", "tv", "short"] as VideoType[]).map((t) => (
              <Link
                key={t}
                to={`/category/${t}`}
                className="px-5 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                {categoryMeta[t].label}
              </Link>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}